export const YES_OR_NO_OPTIONS = [
  { label: "global.yes", value: true },
  { label: "global.no", value: false },
];
